"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    blue: {
        $050: "#ECF5FF",
        $100: "#D0E4FB",
        $200: "#99C3F4",
        $300: "#4C98ED",
        $400: "#1871D8",
        $500: "#005CC7",
        $600: "#0051AF",
    },
    brown: {
        $050: "#F7EFE5",
        $100: "#F0E0CD",
        $200: "#E1C29E",
        $300: "#CA9657",
        $400: "#C18438",
        $500: "#AD6D1F",
    },
    darkBlue: {
        $050: "#F0F2FC",
        $100: "#D7DBF0",
        $200: "#A6AED9",
        $300: "#6471B9",
        $400: "#3948A4",
        $500: "#1A2878",
    },
    fuschia: {
        $050: "#FFEFFD",
        $100: "#ECC9E8",
        $200: "#E5A7DE",
        $300: "#CF7DC6",
        $400: "#BA45AC",
        $500: "#A81897",
    },
    gray: {
        $000: "#FFFFFF",
        $050: "#F8F9F9",
        $100: "#E9EBED",
        $200: "#D8DCDE",
        $300: "#A8B3B8",
        $400: "#8F9BA2",
        $500: "#76848C",
        $600: "#5E6C75",
        $700: "#45545E",
        $800: "#2E3C47",
        $900: "#101B24",
    },
    green: {
        $050: "#E0F7EF",
        $100: "#C3EFE1",
        $200: "#A6E7D2",
        $300: "#5BCCA9",
        $400: "#1DAD80",
        $500: "#008760",
        $600: "#006D4E",
    },
    orange: {
        $050: "#FFEEE3",
        $100: "#FFDFC9",
        $200: "#FFC095",
        $300: "#FFA262",
        $400: "#F08237",
        $500: "#EA6D2E",
        $600: "#D45F24",
    },
    lightBlue: {
        $050: "#E7F9FB",
        $100: "#C4F0F5",
        $200: "#75DBE7",
        $300: "#3ACCDD",
        $400: "#0DAFC5",
        $500: "#008294",
        $600: "#006A78",
    },
    lightGreen: {
        $050: "#EEF8EB",
        $100: "#DEF1D9",
        $200: "#BEE3B5",
        $300: "#9FD591",
        $400: "#69BF55",
        $500: "#1E9300",
    },
    lime: {
        $050: "#F2F5DD",
        $100: "#E0E5C0",
        $200: "#C9D385",
        $300: "#B6C645",
        $400: "#A0B801",
        $500: "#8A9E00",
    },
    red: {
        $050: "#FFECEC",
        $100: "#FFDBDA",
        $200: "#FFBBB9",
        $300: "#F28986",
        $400: "#E75660",
        $500: "#D32F4C",
        $600: "#B5223C",
    },
    yellow: {
        $050: "#FEF6E1",
        $100: "#FEEDC6",
        $200: "#FCDC90",
        $300: "#FBD16B",
        $400: "#FBC338",
        $500: "#F4AF00",
    },
};
//# sourceMappingURL=index.js.map